import { c as _c } from "react/compiler-runtime";
import svgLogo from "common/assets/logo.svg";
import { Dropdown } from "../Dropdown";
import { Button } from "../Button";
import { Menu, ChevronDown, Home, PenSquare } from "lucide-react";
import { AccountMenu } from "../AccountMenu";
import { MobileMenu } from "../MobileMenu";
import { useRegionCode } from "modules/i18n/hooks/useRegionCode";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { useRegionConfig } from "modules/i18n/hooks/useRegionConfig";
import { useViewer } from "common/hooks/data/useViewer";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { AppProps } from "common/lib/getAppServerSideProps";
import { useCallback, useState } from "react";
import clsx from "classnames";
import { donationsUrl } from "../donationsUrl";
import { DevMenu } from "common/components/Header/Topbar/DevMenu";
const handleSkipToContentClick = () => {
  const target = document.getElementById("main-content");
  if (target) {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({
      behavior: prefersReducedMotion ? "auto" : "smooth",
      block: "start"
    });

    // Wait until the scrolling animation is finished before focusing the target element to prevent instantly losing focus again when animating done
    requestAnimationFrame(() => {
      target.focus();
    });
  }
};
interface TopbarProps {
  wide?: boolean;
}
export const Topbar = t0 => {
  "use memo";

  const $ = _c(123);
  const {
    wide
  } = t0;
  const regionCode = useRegionCode();
  const {
    editUrl,
    activeRegions
  } = usePageProps();
  const t = useTranslations("layout.header");
  const regionConfig = useRegionConfig();
  const {
    viewer,
    isAuthor,
    isEditor
  } = useViewer();
  const [isActive, setIsActive] = useState(false);
  const user = viewer?.user;
  let t1;
  if ($[0] !== activeRegions || $[1] !== regionCode) {
    let t2;
    if ($[3] !== regionCode) {
      t2 = t3 => {
        const {
          code
        } = t3;
        return code == regionCode;
      };
      $[3] = regionCode;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = activeRegions.find(t2);
    $[0] = activeRegions;
    $[1] = regionCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedRegion = t1;
  let containerClasses;
  let donationButtonClasses;
  let donations;
  let stayInformedButtonClasses;
  let stay_informed;
  let t2;
  if ($[5] !== activeRegions || $[6] !== regionCode || $[7] !== regionConfig || $[8] !== wide) {
    let t3;
    if ($[15] !== regionCode) {
      t3 = t4 => {
        const {
          code: code_0
        } = t4;
        return code_0 != regionCode;
      };
      $[15] = regionCode;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    const remainingRegions = activeRegions.filter(t3);
    ({
      stay_informed,
      donations
    } = regionConfig);
    const t4 = !wide;
    let t5;
    if ($[17] !== t4 || $[18] !== wide) {
      t5 = clsx("relative mx-auto flex h-10 justify-between p-0! text-black lg:h-12", {
        "tc-container": t4,
        "lg:ml-3": wide
      });
      $[17] = t4;
      $[18] = wide;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    containerClasses = t5;
    const t6 = !donations.promoted;
    let t7;
    if ($[20] !== donations.promoted || $[21] !== t6) {
      t7 = clsx("min-hitbox-44 m-1 items-center rounded-full bg-red-600 px-3 py-1 text-xs font-bold text-white visited:text-white hover:bg-red-500 hover:text-white focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:outline-none md:block lg:px-5 lg:py-2", {
        block: donations.promoted,
        hidden: t6
      });
      $[20] = donations.promoted;
      $[21] = t6;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    donationButtonClasses = t7;
    let t8;
    if ($[23] !== donations.promoted) {
      t8 = clsx("min-hitbox-44 m-1 self-end rounded-full bg-black px-3 py-1 text-xs font-bold text-white visited:text-white hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-black focus:ring-offset-2 focus:outline-none lg:px-5 lg:py-2", {
        "hidden md:block": donations.promoted
      });
      $[23] = donations.promoted;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    stayInformedButtonClasses = t8;
    t2 = remainingRegions.map(_temp);
    $[5] = activeRegions;
    $[6] = regionCode;
    $[7] = regionConfig;
    $[8] = wide;
    $[9] = containerClasses;
    $[10] = donationButtonClasses;
    $[11] = donations;
    $[12] = stayInformedButtonClasses;
    $[13] = stay_informed;
    $[14] = t2;
  } else {
    containerClasses = $[9];
    donationButtonClasses = $[10];
    donations = $[11];
    stayInformedButtonClasses = $[12];
    stay_informed = $[13];
    t2 = $[14];
  }
  let t3;
  if ($[25] !== t2) {
    t3 = <>{t2}</>;
    $[25] = t2;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  const regionDropdownOverlay = t3;
  let t4;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsActive(false);
      setTimeout(_temp2, 50);
    };
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  const handleClose = t4;
  let t5;
  if ($[28] !== isActive) {
    t5 = () => {
      if (isActive) {
        handleClose();
      } else {
        setIsActive(true);
      }
    };
    $[28] = isActive;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  const toggleMenu = t5;
  let t6;
  if ($[30] !== t) {
    t6 = t("menu");
    $[30] = t;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  const t7 = !wide;
  let t8;
  if ($[32] !== t7) {
    t8 = clsx("relative mx-auto", {
      "tc-container": t7
    });
    $[32] = t7;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== t) {
    t9 = t("skip_to_content");
    $[34] = t;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== t9) {
    t10 = <button type="button" onClick={handleSkipToContentClick} className="sr-only text-base focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:border-2 focus:border-black focus:bg-white focus:px-4 focus:py-2 focus:font-bold focus:text-black focus:shadow-lg">{t9}</button>;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== t10 || $[39] !== t8) {
    t11 = <div className={t8}>{t10}</div>;
    $[38] = t10;
    $[39] = t8;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== isActive) {
    t12 = <MobileMenu isActive={isActive} onClose={handleClose} />;
    $[41] = isActive;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== isActive) {
    t13 = clsx("absolute block p-2 text-gray-800 -outline-offset-1 hover:bg-gray-50", {
      invisible: isActive
    });
    $[43] = isActive;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t) {
    t14 = t("menu");
    $[45] = t;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  const t15 = isActive ? -1 : 0;
  let t16;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Menu className="size-6" />;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t13 || $[49] !== t14 || $[50] !== t15 || $[51] !== toggleMenu) {
    t17 = <div className="absolute z-30 w-full lg:hidden"><button id="mobile-menu-button" type="button" className={t13} onClick={toggleMenu} aria-label={t14} aria-expanded={false} aria-controls="mobile-menu-container" tabIndex={t15}>{t16}</button></div>;
    $[48] = t13;
    $[49] = t14;
    $[50] = t15;
    $[51] = toggleMenu;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = process.env.NODE_ENV === "development" && <DevMenu />;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  const t19 = `/${regionCode}`;
  let t20;
  if ($[54] !== t) {
    t20 = t("go_to_homepage");
    $[54] = t;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="hidden p-3 lg:block"><Home className="size-6" /></span>;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="flex h-full grow items-center"><img src={svgLogo.src} alt="" className="mr-1 max-h-5 w-auto min-w-32 grow md:h-5 lg:hidden" /></span>;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t19 || $[59] !== t20) {
    t23 = <a href={t19} aria-label={t20} className="ml-10 flex h-full text-gray-700 -outline-offset-1 hover:bg-gray-50 hover:text-gray-700! max-md:grow lg:-ml-3">{t21}{t22}</a>;
    $[58] = t19;
    $[59] = t20;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] !== t) {
    t24 = t("edition");
    $[61] = t;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== t24) {
    t25 = <span className="ml-3 font-sans text-xs">{t24}:</span>;
    $[63] = t24;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== regionDropdownOverlay || $[66] !== selectedRegion) {
    t26 = selectedRegion && <Dropdown overlay={regionDropdownOverlay}><Button><div className="pr-2 font-bold text-red-600">{selectedRegion.nameInRegionLanguage}</div><ChevronDown className="size-4" /></Button></Dropdown>;
    $[65] = regionDropdownOverlay;
    $[66] = selectedRegion;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] !== t25 || $[69] !== t26) {
    t27 = <div className="hidden h-full lg:block" data-testid="region-dropdown"><div className="relative h-full border-x border-solid border-gray-200"><div className="flex h-full items-center">{t25}{t26}</div></div></div>;
    $[68] = t25;
    $[69] = t26;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== donationButtonClasses || $[72] !== donations.enabled || $[73] !== regionCode || $[74] !== regionConfig || $[75] !== t) {
    t28 = donations.enabled && <a href={donationsUrl({
      regionConfig,
      regionCode,
      campaign: "topbar"
    })} className={donationButtonClasses}>{t("donate")}</a>;
    $[71] = donationButtonClasses;
    $[72] = donations.enabled;
    $[73] = regionCode;
    $[74] = regionConfig;
    $[75] = t;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  let t29;
  if ($[77] !== stayInformedButtonClasses || $[78] !== stay_informed.enabled || $[79] !== stay_informed.topbar || $[80] !== t) {
    t29 = stay_informed.enabled && <a href={stay_informed.topbar.url} className={stayInformedButtonClasses}>{t("get_newsletter")}</a>;
    $[77] = stayInformedButtonClasses;
    $[78] = stay_informed.enabled;
    $[79] = stay_informed.topbar;
    $[80] = t;
    $[81] = t29;
  } else {
    t29 = $[81];
  }
  let t30;
  if ($[82] !== t28 || $[83] !== t29) {
    t30 = <div className="my-1 flex flex-row-reverse sm:flex-row md:mx-2">{t28}{t29}</div>;
    $[82] = t28;
    $[83] = t29;
    $[84] = t30;
  } else {
    t30 = $[84];
  }
  let t31;
  if ($[85] !== t23 || $[86] !== t27 || $[87] !== t30) {
    t31 = <div className="flex grow flex-row flex-wrap items-center max-lg:overflow-hidden">{t23}{t27}{t30}</div>;
    $[85] = t23;
    $[86] = t27;
    $[87] = t30;
    $[88] = t31;
  } else {
    t31 = $[88];
  }
  let t32;
  if ($[89] !== editUrl || $[90] !== isEditor || $[91] !== t) {
    t32 = isEditor && editUrl && <div className="flex h-full"><Button href={editUrl} withDivider={true}><PenSquare className="w-5 pr-1" />{t("user_navbar.edit_page")}</Button></div>;
    $[89] = editUrl;
    $[90] = isEditor;
    $[91] = t;
    $[92] = t32;
  } else {
    t32 = $[92];
  }
  let t33;
  if ($[93] !== isAuthor || $[94] !== t || $[95] !== user) {
    t33 = isAuthor && user?.id && <div className="flex h-full"><Button href={`/profiles/${user.id}/dashboard`} withDivider={true}>{t("user_navbar.dashboard")}</Button></div>;
    $[93] = isAuthor;
    $[94] = t;
    $[95] = user;
    $[96] = t33;
  } else {
    t33 = $[96];
  }
  let t34;
  if ($[97] !== isEditor || $[98] !== t || $[99] !== user) {
    t34 = isEditor && user?.id && <div className="flex h-full"><Button href={`/editorial/dashboards/${user.id}`} withDivider={true}>{t("user_navbar.dashboard")}</Button></div>;
    $[97] = isEditor;
    $[98] = t;
    $[99] = user;
    $[100] = t34;
  } else {
    t34 = $[100];
  }
  let t35;
  if ($[101] !== t32 || $[102] !== t33 || $[103] !== t34) {
    t35 = <div className="hidden h-full md:flex">{t32}{t33}{t34}</div>;
    $[101] = t32;
    $[102] = t33;
    $[103] = t34;
    $[104] = t35;
  } else {
    t35 = $[104];
  }
  let t36;
  if ($[105] !== regionCode || $[106] !== t || $[107] !== user) {
    t36 = !user && <div className="hidden h-full md:flex"><Button href="/become-an-author" withDivider={true}>{t("user_navbar.become_an_author")}</Button><Button href={`/sign_up?return_to=/${regionCode}`} withDivider={true}>{t("user_navbar.signup_reader")}</Button></div>;
    $[105] = regionCode;
    $[106] = t;
    $[107] = user;
    $[108] = t36;
  } else {
    t36 = $[108];
  }
  let t37;
  if ($[109] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <AccountMenu />;
    $[109] = t37;
  } else {
    t37 = $[109];
  }
  let t38;
  if ($[110] !== t35 || $[111] !== t36) {
    t38 = <div className="flex w-auto flex-row items-center border-r">{t35}{t36}{t37}</div>;
    $[110] = t35;
    $[111] = t36;
    $[112] = t38;
  } else {
    t38 = $[112];
  }
  let t39;
  if ($[113] !== containerClasses || $[114] !== t31 || $[115] !== t38) {
    t39 = <div className={containerClasses}>{t18}{t31}{t38}</div>;
    $[113] = containerClasses;
    $[114] = t31;
    $[115] = t38;
    $[116] = t39;
  } else {
    t39 = $[116];
  }
  let t40;
  if ($[117] !== t11 || $[118] !== t12 || $[119] !== t17 || $[120] !== t39 || $[121] !== t6) {
    t40 = <nav className="relative z-20 border-b border-solid border-gray-200 bg-white" data-testid="Topbar" aria-label={t6}>{t11}{t12}{t17}{t39}</nav>;
    $[117] = t11;
    $[118] = t12;
    $[119] = t17;
    $[120] = t39;
    $[121] = t6;
    $[122] = t40;
  } else {
    t40 = $[122];
  }
  return t40;
};
function _temp(t0) {
  const {
    code: code_1,
    nameInRegionLanguage
  } = t0;
  return <a href={`/${code_1}`} key={code_1} role="menuitem" className="block w-full px-2.5 py-3.5 text-left text-xs text-black transition hover:bg-gray-50">{nameInRegionLanguage}</a>;
}
function _temp2() {
  document.getElementById("mobile-menu-button")?.focus();
}